import React, {Component} from 'react';

export default class InputViewer extends Component {

  render() {
    const {value, placeholder} = this.props;

    return (
      <div className="input-viewer">
        {value === '' ? <span className="placeholder">{placeholder}</span> : value}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/pages/persona/inputField/InputViewer.jsx